<template>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  name: 'App',

// metaInfo: {
//   title: 'Default App Title',
//   titleTemplate: '%s | vue-meta Example App',
//   htmlAttrs: {
//     lang: 'en-US'
//   },
//   meta: [
//       { name: 'description', content:  'meta description'},
//       { property: 'og:title', content: "meta og title"},
//       { property: 'og:site_name', content: 'meta site name'},
//       {property: 'og:type', content: 'website'},    
//       {name: 'robots', content: 'index,follow'} 
//   ]
// },

  computed: {
      ...mapState(['token']),
      ...mapGetters(['isAuth']),
  },
  methods: {
      ...mapActions('user', ['getUserLogin']),
  },
  components: {
      //'app-header': Header,
      //'app-footer': Footer
  },
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
